import { overlay, accountHelpWindow, ResetPassword, ForgotUsername, VerificationEmail, RecoverPasswordTab, ForgottenUsernameTab, VerifyEmailTab, recoveryerror, activationResult } from '../login/login.animations';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { UserService } from '../../services/user.service';
import { Account } from '../../models/account';

@Component({
  selector: 'activate',
  templateUrl: './activate.component.html',
  providers: [ UserService ],
  animations: [
	  	overlay,
	  	VerificationEmail,
		RecoverPasswordTab, 
		ForgottenUsernameTab, 
		VerifyEmailTab, 
		recoveryerror,
		accountHelpWindow,
		ResetPassword,
		ForgotUsername,
		activationResult
	]
})
export class ActivationComponent implements OnInit {

	public accounts: Account;

	constructor(private userService: UserService,
				private router: Router,
				private sanitizer: DomSanitizer,
				private route: ActivatedRoute,
				private location: Location) { }
	
	key: any;
	title: any;
	header: any;
	subtitle: any;
	headerHeight: any;
	headerAlign: any;

	activation = new Activation('');
	activationerr: any;
	activationsuccess: any;

	accountactive: boolean;
	loggedIn: boolean;
	showerror: boolean;


	/**
	* Activate a user with a provided key (ngModel)
	**/
	activate() {

		Promise.resolve( this.userService.activate( this.activation.key ) ).then( (resp) => {
			if ( resp.code == 200 ) {
				this.activationsuccess = resp.message;
				this.accountactive = true;
			} else {
				this.activationerr = resp.err;
				this.accountactive = false;
			}
		});

	}


	/**
	* Authorize a logged in user to make a purchase
	**/
	authorize() {
		// Send the authorization request
		this.userService.authorizeUser().subscribe((user) =>  {
			this.accounts = user;
			if ( user ) {
				this.loggedIn = true;
				console.log( user );
				if ( user[0].accountstate == 1 )
					this.accountactive = true
			}
		});
	}



	/**
	* Application Start
	**/
	/* On with the show */
	ngOnInit() {
		this.authorize();
		this.title = 'Activate your Identity';
		this.headerHeight = '500px';
		
		this.key = this.route.snapshot.params['id'];
		if (this.key)
			this.activation.key = this.key;
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-shop.jpg")' );
	}

}

export class Activation {
	constructor(
		public key: string
	) {}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/user-activate/activate.component.ts